import { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { UserContext } from "../../contexts/UserContext";
import { SearchTask, TaskData } from "../types";

// ----------------------------------------------------------------------

const OutstandingSearchesContext = createContext<TaskData>({} as TaskData);

function OutstandingSearchesContextProvider({ children }: { children: JSX.Element }) {
  const { user } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [outstandingSearches, setOutstandingSearches] = useState<SearchTask[]>([]);
  const [assignedToMe, setAssignedToMe] = useState<boolean>(true);

  let userName: string | undefined = useMemo(() => {
    let name = user?.name.toLowerCase();
    if (name) {
      return name
        .split(",")
        .map((p: string) => p.trim())
        .reverse()
        .join(" ");
    }
  }, [user]);

  const searchOutstandingSearches = async () => {
    setLoading(true);
    const { data } = await axios.get<SearchTask[]>(
      `/api/outstandingchecks/OutstandingSearches?username=${assignedToMe ? userName : ""}`
    );
    setOutstandingSearches(data);
    setLoading(false);
  };

  useEffect(() => {
    if (user?.name) {
      searchOutstandingSearches();
    }
  }, [user, assignedToMe]);

  return (
    <OutstandingSearchesContext.Provider
      value={{
        loading,
        tasks: outstandingSearches,
        setTasks: setOutstandingSearches,
        assignedToMe,
        setAssignedToMe
      }}
    >
      {children}
    </OutstandingSearchesContext.Provider>
  );
}

export { OutstandingSearchesContextProvider, OutstandingSearchesContext };
